/**
 * @desc 分页
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<
  defs.basics.IPage<defs.basics.CertBatteryResponseDto>
>;
export function request(
  params: API.basics.certBattery.page.Params,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/certBattery/page`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
